/**
 * Object describing how feed items are filtered in the view.
 * @enum {string}
 */
export const FilterType = {
    NEWEST: 'newest',
    UNREAD: 'unread',
    STARRED: 'starred',
};
